import script from "./AbsenceDocumentPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceDocumentPicker.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceDocumentPicker.vue?vue&type=style&index=0&id=07dac6d6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07dac6d6"]])

export default __exports__